import React from 'react';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import ArticleIcon from '@mui/icons-material/Article';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import Moment from 'moment';
import 'moment/locale/pt-br';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useTheme } from '@mui/material/styles';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useAuth } from '../hooks/useAuth';
import { useQuery } from '../hooks/useQuery';
import { useSnackbar } from '../hooks/useSnackbar';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { encryptData, isCnpj, serializeQueryString } from '../utils';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import Menu from '@mui/material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Pagination from '@mui/material/Pagination';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import RowPagamentoDireto from '../components/RowPagamentoDireto';
import RowPagamentoDiretoDetails from '../components/RowPagamentoDiretoDetails';

let debounce = null;

const ListaPagamentosPage = () => {
  const theme = useTheme();
  const snackbar = useSnackbar();
  const { user, isUsuarioSebrae } = useAuth();
  const { listarPagamentoDireto, listarFornecedores, deletarPagamentoDireto } =
    useQuery();
  const navigate = useNavigate();
  const [pagamentos, setPagamentos] = React.useState([]);
  const datePickerRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const [dataInicio, setDataInicio] = React.useState(Moment().startOf('year'));
  const [dataFim, setDataFim] = React.useState(Moment().endOf('year'));
  const [queryParams, setQueryParams] = React.useState({
    fornecedor: '',
    data_abertura: '',
    fluig: '',
    tipo_documento: 0,
  });
  const [options, setOptions] = React.useState([]);
  const [loadingAutocomplete, setLoadingAutocomplete] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [page, setPage] = React.useState(1);
  const [total, setTotal] = React.useState(0);
  const [lastPage, setLastPage] = React.useState(0);
  const [runRequest, setRunRequest] = React.useState(false);

  React.useEffect(() => {
    if (datePickerRef) {
      // datePickerRef.current.children[0].classList.remove('Mui-error');
      // datePickerRef.current.children[1].classList.remove('Mui-error');
    }
  }, [datePickerRef]);

  React.useEffect(() => {
    listarPagamentos(1);
    const interval = setInterval(() => {
      if (user) {
        listarPagamentos(1);
      }
    }, 300000);

    return () => clearInterval(interval);
  }, [runRequest]);

  const onClickEdit = (pagamento) => {
    navigate(
      `/dashboard/criar-pagamento-direto?pagamento_id=${encryptData(
        pagamento.id,
      )}`,
    );
  };

  const getOptionsFilter = () => {
    if (user.role_id === 6) {
      return [
        {
          text: 'PAGAMENTO-ALI-TD',
          value: 'pagamentoAliTd',
        },
      ];
    }

    return [
      {
        text: 'FUNDO FIXO',
        value: 'fundoFixo',
      },
      {
        text: 'UGP FOLHA',
        value: 'ugpFolha',
      },
      {
        text: 'UGP TRIBUTOS',
        value: 'ugpTributos',
      },
      {
        text: 'FATURA',
        value: 'fatura',
      },
      {
        text: 'GUIA/TAXA/ISS',
        value: 'guiasTaxasISS',
      },
      {
        text: 'PAGAMENTO DIRETO',
        value: 'pagamentoDireto',
      },
      {
        text: 'REEMBOLSO',
        value: 'reembolso',
      },
      {
        text: 'PAGAMENTO-ALI-TD',
        value: 'pagamentoAliTd',
      },
      {
        text: 'PAGAMENTO BOLSISTAS ALI',
        value: 'pagamentoBolsistasAli',
      },
      {
        text: 'GUIAS TERCEIRIZADAS',
        value: 'guiasTerceirizadas',
      },
      {
        text: 'ANTECIPAÇÃO A FORNECEDORES',
        value: 'antecipacaoFornecedores',
      },
      {
        text: 'CANCELAMENTO DE VENDA COM DEVOLUÇÃO',
        value: 'cancelaVendaComDevolucao',
      },
      {
        text: 'PAGAMENTO A MAIOR EFETUADO PELO CLIENTE',
        value: 'pagamentoMaiorPeloCliente',
      },
    ];
  };

  const onClickDeletar = async (pagamento) => {
    try {
      const ok = await window.confirm(
        'Tem certeza que deseja excluir o pagamento direto?',
      );

      if (!ok) return;

      const result = await deletarPagamentoDireto(pagamento.id);

      if (result && result.data && result.data.success) {
        snackbar.showSnackbar('Pagamento excluído com sucesso');
        listarPagamentos(1);
        return;
      } else {
        snackbar.showSnackbar(result.data.message);
        return;
      }
    } catch (error) {}
  };

  const handleChange = (event, value) => {
    setPage(value);
    listarPagamentos(value);
  };

  const listarPagamentos = async (pagina = 1) => {
    try {
      // if (!queryParams.cnpj) return;
      setLoading(true);
      const result = await listarPagamentoDireto(
        serializeQueryString(queryParams),
        pagina,
      );
      setPagamentos(result.data.data.data);
      setPage(result.data.data.current_page);
      setLastPage(result.data.data.last_page);
      setTotal(result.data.data.total);
    } catch (error) {
      snackbar.showSnackbar(error.toString());
    } finally {
      setLoading(false);
    }
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) =>
      option.cnpj_sem_pontos + option.nome_fornec + option.cnpj_fornec,
  });

  const onChangeAutoComplete = (event) => {
    if (event.target.value.length > 0) {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        fornecedores(event.target.value);
      }, 1000);
    } else {
      setOptions([]);
    }
  };

  const handleChangeInicio = (value) => {
    setDataInicio(value);
    setQueryParams({
      ...queryParams,
      data_abertura: value.format('YYYY-MM-DD'),
    });
  };

  const fornecedores = async (term) => {
    setLoadingAutocomplete(true);
    const newTerm = isCnpj(term) ? term.replace(/[^a-zA-Z0-9]/g, '') : term;

    const result = await listarFornecedores(newTerm);
    if (result && result.data && result.data.data) {
      const arr = result.data.data.map((item) => ({
        ...item,
        cnpj_sem_pontos: item.cnpj_fornec.replace(/[^a-zA-Z0-9]/g, ''),
        showDetails: false,
      }));
      setOptions(arr);
    }
    setLoadingAutocomplete(false);
  };

  return (
    <Box
      mt={8}
      sx={{ width: '100%', background: '#FAFCFF', minHeight: '100vh' }}
    >
      <AppBar position="static" color="primary" style={{ padding: 10 }}>
        <Grid container spacing={0}>
          <Grid item display="flex" alignItems="center">
            <ArticleIcon
              sx={{
                fontSize: 40,
              }}
            />
            <span style={{ color: 'white', fontSize: 20 }}>
              Pagamento Direto
            </span>
          </Grid>
        </Grid>
      </AppBar>

      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Grid item sm={12} display="flex" justifyContent="flex-end">
          <Button
            onClick={() => {
              navigate(`/dashboard/criar-pagamento-direto`);
            }}
            variant="contained"
            startIcon={<AddIcon />}
          >
            Novo Pagamento Direto
          </Button>
        </Grid>
        <div className="grid_app">
          <div
            style={{
              width: '100%',
              overflowX: 'scroll',
              overflowY: 'hidden',
            }}
          >
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress style={{ marginTop: 60 }} />
              </Box>
            ) : (
              <div>
                <table className="app_table">
                  <thead
                    style={{
                      color: theme.palette.primary.main,
                      borderTop: `8px solid ${theme.palette.primary.light}`,
                    }}
                  >
                    <tr>
                      <th style={{ width: '10%', textAlign: 'center' }}>
                        Nº Fluig
                      </th>
                      <th style={{ width: '15%', textAlign: 'center' }}>
                        Nº Documento
                      </th>
                      <th style={{ width: '20%', textAlign: 'center' }}>
                        Status
                      </th>
                      <th style={{ width: '10%', textAlign: 'center' }}>
                        Data de abertura
                      </th>
                      <th style={{ width: '20%', textAlign: 'center' }}>
                        Fornecedor
                      </th>
                      <th style={{ width: '25%', textAlign: 'center' }}>
                        Tipo de documento
                      </th>
                      <th style={{ width: '5%' }}></th>
                    </tr>
                  </thead>

                  <tbody>
                    {pagamentos && pagamentos.length === 0 ? (
                      <tr>
                        <td style={{ textAlign: 'center' }} colSpan={7}>
                          Nenhum cadastro encontrado.
                        </td>
                      </tr>
                    ) : null}
                    {pagamentos &&
                      pagamentos.map((pgto, index) => (
                        <React.Fragment>
                          <RowPagamentoDireto
                            key={`RowPagamentoDireto-${index}`}
                            pagamento={pgto}
                            index={index}
                            onClickEdit={onClickEdit}
                            onClickDelete={onClickDeletar}
                            clickExpand={() => {
                              pgto.showDetails = !pgto.showDetails;
                              setPagamentos([...pagamentos]);
                            }}
                          />

                          {pgto.showDetails && (
                            <RowPagamentoDiretoDetails
                              pagamento={pgto}
                              key={`RowPagamentoDiretoDetails-${index}`}
                            />
                          )}
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
                <Box
                  style={{ marginTop: 20 }}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Pagination
                    count={lastPage}
                    page={page}
                    color={'primary'}
                    onChange={handleChange}
                  />
                </Box>
              </div>
            )}
          </div>
          <div>
            <Card
              variant="outlined"
              style={{
                borderTop: `8px solid ${theme.palette.primary.light}`,
              }}
            >
              <CardContent>
                <div
                  style={{
                    color: '#0e72b8',
                    marginTop: 0,
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <FilterAltIcon color="primary" />
                  Filtro
                </div>
                <p style={{ color: '#0e72b8', fontWeight: 'bold' }}>Nº Fluig</p>
                <TextField
                  style={{ width: '100%', marginBottom: '0.8rem' }}
                  id="outlined-basic"
                  label="Fluig"
                  type="number"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .substring(0, 16)
                      .replace(/[^0-9.]/g, '');
                  }}
                  inputProps={{
                    min: 0,
                    maxLength: 16,
                  }}
                  value={queryParams.fluig}
                  onChange={({ target }) =>
                    setQueryParams({ ...queryParams, fluig: target.value })
                  }
                  variant="outlined"
                />
                <p style={{ color: '#0e72b8', fontWeight: 'bold' }}>
                  Fornecedor
                </p>
                <Autocomplete
                  noOptionsText="Nenhuma opção encontrada"
                  loadingText="Carregando..."
                  getOptionLabel={(option) =>
                    `${option.nome_fornec} - ${option.cnpj_fornec}`
                  }
                  options={options}
                  id="controlled-demo"
                  fullWidth
                  // value={fornecedor}
                  loading={loadingAutocomplete}
                  filterOptions={filterOptions}
                  onChange={(event, newValue) => {
                    if (newValue == null) {
                      setQueryParams({ ...queryParams, fornecedor: '' });
                      queryParams.fornecedor = '';
                      setOptions([]);
                      listarPagamentos(1);
                    } else {
                      setQueryParams({
                        ...queryParams,
                        fornecedor: newValue.nome_fornec,
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      onChange={onChangeAutoComplete}
                      {...params}
                      label="Fornecedor Nome ou CNPJ"
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {loadingAutocomplete ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
                <p style={{ color: '#0e72b8', fontWeight: 'bold' }}>
                  Tipo de Documento
                </p>
                <Select
                  style={{ height: 40 }}
                  value={queryParams.tipo_documento}
                  onChange={(e) => {
                    setQueryParams({
                      ...queryParams,
                      tipo_documento: e.target.value,
                    });
                  }}
                  fullWidth
                >
                  <MenuItem disabled value={0}>
                    Selecione o tipo de documento
                  </MenuItem>
                  {getOptionsFilter().map((item) => (
                    <MenuItem value={item.value}>{item.text}</MenuItem>
                  ))}
                </Select>
                <p style={{ color: '#0e72b8', fontWeight: 'bold' }}>
                  Data Abertura
                </p>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <Box>
                    <MobileDatePicker
                      ref={datePickerRef}
                      label="Data início transação"
                      inputFormat="DD/MM/YYYY"
                      value={dataInicio}
                      onChange={handleChangeInicio}
                      renderInput={(params) => (
                        <TextField
                          error={false}
                          style={{ width: '100%' }}
                          {...params}
                        />
                      )}
                    />
                  </Box>
                </LocalizationProvider>

                <Button
                  variant="contained"
                  onClick={() => {
                    listarPagamentos(1);
                  }}
                  style={{ width: '100%', marginTop: 20 }}
                >
                  Buscar
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setQueryParams({
                      fornecedor: '',
                      data_abertura: '',
                      fluig: '',
                      tipo_documento: 0,
                    });
                    setDataInicio(Moment().startOf('year'));
                    setRunRequest(!runRequest);
                  }}
                  style={{ width: '100%', marginTop: 20 }}
                >
                  Limpar
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </Grid>
    </Box>
  );
};

export default ListaPagamentosPage;
